import React, { useEffect, useRef, useState } from 'react';
import { Form, InputRef } from 'antd';
import { Link } from 'react-router-dom';
import { validateEmail } from 'utils/validate';
import AuthLayout from 'components/common/AuthLayout/AuthLayout';
import { emailRules, passwordRules } from 'utils/formRules';
import { ButtonCommon, InputCommon } from 'components/common';
import useAuthContext from 'stores/auth-context';
import { AxiosError } from 'axios';
import FormCommon from 'components/common/Form/FormCommon';

const LoginPage: React.FC = () => {
  const [emailValid, setEmailValid] = useState<boolean | null>(null);
  const [form] = Form.useForm();
  const { onSignIn, loading } = useAuthContext();
  const emailInputRef = useRef<InputRef>(null);
  const handleEmailChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    if (!value) {
      setEmailValid(true);
    } else {
      try {
        await validateEmail(value);
        setEmailValid(false);
      } catch {
        setEmailValid(true);
      }
    }
  };

  const handleLogin = async () => {
    try {
      const value = await form.validateFields();
      const emailTolowerCase = value?.email?.toLowerCase();
      if (value) {
        const email = emailTolowerCase?.trim();
        const password = value.password?.trim();
        await onSignIn({ email, password, remember: true });
      }
    } catch (error) {
      const axiosError = error as AxiosError;
      if (axiosError?.status === 404) {
        setEmailValid(true);
        form.setFields([{ name: 'email', errors: ['Không tìm thấy gmail của bạn'] }]);
      } else if (axiosError?.status === 400) {
        form.setFields([
          { name: 'password', value: '', errors: ['Sai mật khẩu, thử lại lần nữa hoặc chọn quên mật khẩu'] },
        ]);
      }
    }
  };
  useEffect(() => {
    emailInputRef.current?.focus();
  }, [emailValid]);
  return (
    <AuthLayout>
      <div className='text-center gap-[4px] flex flex-col'>
        <h3 className='text-[24px] font-[700] leading-[32px] text-[var(--textBlack1E)]'>Chào mừng bạn trở lại!</h3>
        <p className='text-[var(--textGray)] font-[400] text-[14px] leading-[22px]'>
          Vui lòng điền đầy đủ thông tin bên dưới để tiếp tục
        </p>
      </div>

      <FormCommon
        form={form}
        layout='vertical'
        className='form-liemlam form-login'
        initialValues={{ remember: true }}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
            handleLogin();
          }
        }}
      >
        <Form.Item label='Email:' name='email' rules={emailRules} hasFeedback>
          <InputCommon
            twSize='md'
            type='text'
            placeholder='Nhập vào email của bạn...'
            onChange={handleEmailChange}
            ref={emailInputRef}
          />
        </Form.Item>

        <Form.Item label='Mật khẩu:' name='password' rules={passwordRules} hasFeedback>
          <InputCommon type='password' placeholder='Nhập vào mật khẩu của bạn...' twSize='md' />
        </Form.Item>

        {/* <Form.Item name='remember' valuePropName='checked'>
          <Checkbox>Lưu đăng nhập</Checkbox>
        </Form.Item> */}
      </FormCommon>
      <ButtonCommon color='basic' fullWidth radius='rounded' size='md' onClick={handleLogin} loading={loading}>
        Đăng nhập
      </ButtonCommon>
      <div className='text-center'>
        <Link to='/forgot-password' className='text-[var(--sematicColor)] text-[16px] font-[500] leading-[24px]'>
          Quên mật khẩu?
        </Link>
      </div>
    </AuthLayout>
  );
};

export default LoginPage;
